import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
//components
import BasketItemList from "components/basket/BasketItemListN";
import WithLoading from "components/Hoc/WithLoading";
import EmptyBasket from "components/basket/EmptyBasket";
import { FixedFooter, ErrorComponent } from "components";
import ConditionalRenderer from "components/ConditionalRenderer";
import { TranslationText } from "components/TextTranslationContainer";
import AddUserInfoForm from "components/Modals/AddUserInfoForm";  
import PaymentSummary from "components/payement-summary";
import { PageHeaderV2 } from "components/PageHeader";
import { CustomButton } from "components/Button";
import { DownArrow } from "config/Svgs";
import { RenderTotalPrice } from "components/DisplayPrice";
//actions
import { CartAction, NotPersistAction, OrderAction } from "store/actions";
//custom hooks
import { useWindowLocation } from "hooks";
import { useUserWallet } from "hooks";
import { useSuccesOrder, useDineIn } from "modules/dine-in/hooks";
// constants utils
import C from "Constants";
import { calculateCartGrossAmount } from "utils/Utils";
import { errorNotification } from "utils/Utils";
//services / features
import usePaymentHelper from "features/payment-helpers/usePaymentHelper";
// dine components
import SpecialNote from "components/item/SpecialNote";
import { Alert } from "components/ErrorComponent";
import DineInAvailablePaymentOptions from "../components/PaymentOptions/DineInAvailablePaymentOptions";
import DineInSplitBill, {
  SplitBillTypeKeys,
} from "../components/DineInSplitBill";
import DineInTableNo from "../components/DineInTableNo";
import Tips from "../components/Tips";

const splitBillKeys = Object.values(SplitBillTypeKeys);

//
function Checkout() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    params,
    router,
    queryParam,
    DomainType,
    goToLogin,
    goToSettings,
    goToPaymentOptions,
    goToHome
  } = useDineIn();

  const handleSuceessOrderRoute = useSuccesOrder();

  const [openSplitBill, setOpenSplitBill] = useState(false);

  const windowRouter = useWindowLocation();
  const queryParams = queryString.parse(location?.search);
  const reduxState = useSelector((state) => state);
  const { orderSuccess } = reduxState.NotPersist;
  const { error: discountError } = reduxState.Discounts;
  const { discountModal } = reduxState.NotPersist;
  const { discountInfo } = reduxState.Discounts;
  const { selectedStore } = reduxState.store;
  // const { selectedTip } = useSelector((state) => state.TipMethodsReducer);
  const { ordered, splitedItems, openSplitBill: openSplitBillRedux } = useSelector((state) => state.order);

  const {
    cart,
    cartTotal,
    amountAfterDiscount,
    cartError,
    totalOrdersGrossAmount,
    split,
    orderSplReq,
    dineInServiceFee,
  } = reduxState.cart;

  //varables

  const userWallet = useUserWallet();

  const redirectLink = {
    success: `dine-in/checkout?${queryParam}&payment=success`,
    failure: `dine-in/checkout?${queryParam}&payment=failure`,
  };

  const { isLoading } = usePaymentHelper(redirectLink, handleSuceessOrderRoute);

  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState(null);

  const updateCart = (props) => {
    const {
      itemsGrossAmount,
      itemsNetPrice,
      orderGrossAmount,
      totalOrdersGrossAmount,
      dineInServiceFeeAmount,
    } = calculateCartGrossAmount(cart, discountInfo, userWallet, ordered);

    const payload = {
      originalPrice: itemsNetPrice,
      amountAfterDiscount: itemsGrossAmount,
      itemsGrossAmount,
      orderGrossAmount,
      totalOrdersGrossAmount,
      dineInServiceFeeAmount,
    };

    if (props?.removeTip || cart?.length <= 0) {
      payload.tipAmount = null;
    }

    dispatch(CartAction.updateCartPrice(payload));
  };

  useEffect(() => {
    updateCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, discountInfo, dineInServiceFee?.percentage, userWallet, ordered]);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (action === "POP") {
        dispatch(NotPersistAction.toggleOrderPlaceModel(false));
        if (cart?.length <= 0) {
          sessionStorage.removeItem("paymentVerified");
          windowRouter(
            `/dine-in/?${queryParam}`,
            `/${params.domainName}/dine-in/?${queryParam}`,
            DomainType
          );
        }
      }
    });

    const returnToHome = () => {
      if (
        ordered.allOrders?.length <= 0 &&
        cart?.length <= 0 &&
        !orderSuccess
      ) {
        sessionStorage.removeItem("paymentVerified");
        windowRouter(
          `/dine-in/?${queryParam}`,
          `/${params.domainName}/dine-in/?${queryParam}`,
          DomainType
        );
      }
    };
    returnToHome();
    return () => {
      unlisten();
    };
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSuccess, history]);

  const increaseItemQuantity = (id, index) => {
    const payload = { id, index };
    dispatch(CartAction.increaseItemQuantity(payload));
    updateCart();
  };
  const decreaseItemQuantity = (id, index) => {
    const payload = { id, index };
    dispatch(CartAction.decreaseItemQuantity(payload));
    updateCart();
  };

  const goBack = () => {
    if (ordered?.splitBills.length > 0) {
      return;
    }
    router(
      "/dine-in",
      `/${params.domainName}/dine-in/`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };

  useEffect(() => {
    if (cartError) {
      errorNotification(cartError, "top-center");
      setTimeout(() => {
        dispatch(CartAction.clearCartError());
      }, 3000); // Clear error after 3 seconds
    }
  }, [cartError, dispatch]);

  useEffect(() => {
    if (((splitedItems?.length > 0 || ordered?.splitBills?.length > 0) && cart?.length === 0) || openSplitBillRedux) {
      setOpenSplitBill(true);
      dispatch(OrderAction.setOpenSplitBill(false))
    }
  }, [splitedItems, ordered?.splitBills, openSplitBillRedux, cart?.length]);

  useEffect(() => {
    if (typeof selectedStore?.dineInServiceFee !== "undefined") {
      dispatch(CartAction.setDineInServiceFee({
        percentage: selectedStore?.dineInServiceFee,
      }));
    }
  }, [dispatch, selectedStore?.dineInServiceFee]);


  useEffect(() => {
    if(cart?.length === 0 && ordered?.allOrders?.length === 0){
      goToHome()
    }
  }, [cart, ordered?.allOrders]);

  return (
    <WithLoading loading={isLoading}>
      <div className="checkout-page min-h-app-height store-page-popup">
        <PageHeaderV2
          pageTitle={"Your Order"}
          authClick={goToLogin}
          userClick={goToSettings}
          containerStyleProps={{
            style: {
              position: "sticky",
              zIndex: 5,
              top: 0,
              backgroundColor: "white",
              width: "98.9%",
              margin: "0 auto",
            },
          }}
          headerStyleProps={{
            className: "p-5",
          }}
        />
        {ordered?.allOrders?.length <= 0 &&
        cart?.length <= 0 &&
        !orderSuccess ? (
          <EmptyBasket backToHome={goBack} />
        ) : (
          <>
            <div className="p-5 flex flex-col gap-8">
              {/* table no */}
              <ConditionalRenderer
                condition={queryParams?.[C.DINE_SERVICE_TYPE.TABLE_NUMBER]}
              >
                <DineInTableNo
                  buttonText={"Add discount code "}
                  tableNo={queryParams?.[C.DINE_SERVICE_TYPE.TABLE_NUMBER]}
                />
              </ConditionalRenderer>
              {/* basket list */}
              <ConditionalRenderer
                condition={cart?.length > 0 || ordered?.allOrders?.length > 0}
              >
                <BasketItemList
                  {...{ increaseItemQuantity, decreaseItemQuantity }}
                  onSubHeaderClick={() => {
                    router(
                      "/dine-in",
                      `/${params?.domainName}/dine-in/`,
                      DomainType,
                      null,
                      `?${queryParam}`
                    );
                  }}
                />
              </ConditionalRenderer>
              <ConditionalRenderer
                condition={ordered?.splitBills?.length === 0}
              >
                <SpecialNote
                  value={orderSplReq ?? ""}
                  onChange={(e) =>
                    dispatch(CartAction.setOrderSplreq(e?.target?.value))
                  }
                />
              </ConditionalRenderer>
              {/* Tip */}
              <ConditionalRenderer
                condition={
                  cart && cart?.length > 0 && ordered?.splitBills?.length === 0
                }
              >
                <Tips />
              </ConditionalRenderer>
              {!discountModal && discountError && cart?.length >= 1 && (
                 <Alert type="warning" title={discountError} />
              )}
              {/* Payment Summary */}
              <PaymentSummary
                cartTotal={cartTotal}
                deliveryFee={0}
                dineInServiceFee={dineInServiceFee}
                taxRate={selectedStore?.taxRate ?? 0}
                amountAfterDiscount={amountAfterDiscount}
                userWallet={userWallet}
                page="dine-in"
                updateCart={updateCart}
                isSplitInProgress={
                  splitedItems?.length > 0 || ordered?.splitBills?.length > 0
                }
              />
              {/* Split Bill */}
             {(splitedItems?.length > 0 || ordered?.splitBills?.length > 0 || split || ordered?.allOrders?.length > 0) && <button
                className="flex justify-between items-center outline-none border-[1.5px] border-brand-base-primary rounded-16x bg-brand-light-base-primary p-4"
                onClick={() => setOpenSplitBill(true)}
              >
                <TranslationText
                  className={`text-16x font-medium capitalize ${
                    +split?.amount > 0 ? "text-brand-base-primary" : ""
                  }`}
                  text={
                    splitBillKeys.includes(split?.type)
                      ? (split?.title ?? split?.type)
                          ?.replaceAll("-", " ")
                          ?.toLowerCase() + " Split Applied"
                      : "Split Bill"
                  }
                />
                <DownArrow />
              </button>}
              {/* when to pay */}
              <DineInAvailablePaymentOptions
                setSelectedPaymentOptions={setSelectedPaymentOptions}
                validStorePaymentOptions={selectedStore?.dineInPaymentOptions}
                selectedPaymentOptions={selectedPaymentOptions}
                isSplitInProgress={
                 ( (splitedItems?.length > 0 || ordered?.splitBills?.length > 0) && cart?.length === 0) || split
                }
              />
              {/* <DineInTableSplitBill /> */}
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <FixedFooter
              containerStyleProps={{ className: "dummy-class" }}
              innerStyleProps={{ className: "bg-dark-blue-100 p-4 " }}
            >
              <RenderTotalPrice total={split ? split?.amount :totalOrdersGrossAmount} />
              <CustomButton
                className="w-full"
                disabled={!selectedPaymentOptions?.id}
                onClick={() => goToPaymentOptions(selectedPaymentOptions)}
              >
                <TranslationText
                  text={
                    selectedPaymentOptions?.id
                      ? selectedPaymentOptions?.title
                      : "Place Order"
                  }
                  className="text-white"
                />
              </CustomButton>
            </FixedFooter>
            <DineInSplitBill open={openSplitBill} setOpen={setOpenSplitBill} />
          </>
        )}
         <AddUserInfoForm
        closeOnBgClick={() => {}}
      />
      </div>
    </WithLoading>
  );
}

export default Checkout;
